import {
	Activity,
	BarChart3,
	Boxes,
	FileText,
	KeyRound,
	LayoutDashboard,
	Users,
} from "lucide-react";
import type { ComponentType, ReactNode } from "react";
import { AccountsTab } from "./components/AccountsTab";
import { AnalyticsTab } from "./components/AnalyticsTab";
import { ApiKeysTab } from "./components/ApiKeysTab";
import { GroupsTab } from "./components/GroupsTab";
import { LogsTab } from "./components/LogsTab";
import { OverviewTab } from "./components/OverviewTab";
import { RequestsTab } from "./components/RequestsTab";

export interface DashboardRoute {
	path: string;
	label: string;
	icon: ComponentType<{ className?: string }>;
	title: string;
	subtitle: string;
	element: ReactNode;
	/** Only show this route when gatewayMode is enabled. */
	gatewayOnly?: boolean;
}

export const dashboardRoutes: DashboardRoute[] = [
	{
		path: "/",
		label: "Overview",
		icon: LayoutDashboard,
		title: "Dashboard Overview",
		subtitle: "Monitor your ccflare performance and usage",
		element: <OverviewTab />,
	},
	{
		path: "/analytics",
		label: "Analytics",
		icon: BarChart3,
		title: "Analytics",
		subtitle: "Deep dive into your usage patterns and trends",
		element: <AnalyticsTab />,
	},
	{
		path: "/requests",
		label: "Requests",
		icon: Activity,
		title: "Request History",
		subtitle: "View detailed request and response data",
		element: <RequestsTab />,
	},
	{
		path: "/accounts",
		label: "Accounts",
		icon: Users,
		title: "Account Management",
		subtitle: "Manage provider accounts and authentication settings",
		element: <AccountsTab />,
	},
	{
		path: "/keys",
		label: "API Keys",
		icon: KeyRound,
		title: "API Keys",
		subtitle: "Manage gateway API keys for client access",
		element: <ApiKeysTab />,
		gatewayOnly: true,
	},
	{
		path: "/groups",
		label: "Groups",
		icon: Boxes,
		title: "Routing Groups",
		subtitle: "Manage routing groups for accounts and API keys",
		element: <GroupsTab />,
		gatewayOnly: true,
	},
	{
		path: "/logs",
		label: "Logs",
		icon: FileText,
		title: "System Logs",
		subtitle: "Real-time system logs and debugging information",
		element: <LogsTab />,
	},
];
